import { ContentBlock } from '$components/ContentBlock';
import { useFragment } from '$contentful-gql/fragment-masking';
import { textFragment } from '$providers/common';
import cn from 'classnames';
import { HTMLAttributes, useEffect, useRef } from 'react';

import { GalleryType, IGalleryContent } from './';

export function GalleryContent(
  props: IGalleryContent & HTMLAttributes<HTMLElement>,
) {
  const { className, item, index, active, type, heights } = props;

  const itemText = useFragment(textFragment, item);
  const typeClasses: Record<GalleryType, string> = {
    light: 'text-grey-100',
    dark: 'text-white',
  };

  const contentElement = useRef(null);
  const refHeight = useRef(null);
  refHeight.current = heights;

  useEffect(() => {
    if (typeof refHeight.current === 'function')
      refHeight.current(
        window.innerWidth < 1024
          ? contentElement.current.getBoundingClientRect().height
          : contentElement.current.scrollHeight,
      );
  }, []);

  return (
    <div
      ref={contentElement}
      key={index}
      className={cn(
        'duration-1000 absolute w-full px-4 lg:px-8',
        active ? 'opacity-100' : 'opacity-0',
      )}
    >
      <ContentBlock
        className={cn(className, typeClasses[type])}
        layout={'left'}
        heading={itemText.title}
        subHeading={itemText.subtitle}
        content={itemText.description}
        type={type}
        size={'gallery'}
        richText={itemText.richText}
        speedMultiplier={2.5}
      />
    </div>
  );
}
